export default "__VITE_ASSET__ea2bd215__"